//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CloneAssembly",1,0],[0,"FileFormat",1,0],[0,"FileNote",1,0],[0,"FileUnits",1,0],[0,"Output",1,0],[1,"SelectedObjects",0,"SelectNXObjectList",0],[0,"TargetLocation",1,0],[0,"UseCloneSelection",1,0]],[[["numChanges"],"GetIncrementalChanges",{R_:{changes:"PcbExchange.IncrementalChange[]"}},0,0],[["changes"],"SetIncrementalChanges",{},1,0],[[],"RunPreExportIncrementalHook",{},0,0],[[],"CompareAssembly",{R_:{hasChanges:''}},0,0]],[]];
SPLM.PcbExchange.IncrementalExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.IncrementalExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.IncrementalExportBuilder.FormatEnum = Object.freeze({
    "Idx2" : "Idx2", "Idx3" : "Idx3"});

SPLM.PcbExchange.IncrementalExportBuilder.TargetLocationEnum = Object.freeze({
    "Os" : "Os", "TeamcenterCS" : "TeamcenterCS"});

SPLM.PcbExchange.IncrementalExportBuilder.ExportUnitsEnum = Object.freeze({
    "Mm" : "Mm", "Thou" : "Thou"});

export default SPLM;